/**
 * Intercom is injected by smartsuite web,
 * here we are just tyring to ask Intercom to open particular article.
 * It doesn't work in:
 *  - automation-iui standalone mode
 *  - local env
 */

const ARTICLE_INTRODUCTION_TO_AUTOMATIONS = 4857223;
const ARTICLE_AUTOMATION_TRIGGERS = 5162303;
const ARTICLE_AUTOMATION_ACTIONS = 5163903;
const ARTICLE_SMARTSUITE_LIMITS = 4759983;

export const intercomOpenAutomationsArticle = (): void =>
  intercomOpenArticleById(ARTICLE_INTRODUCTION_TO_AUTOMATIONS);

export const intercomOpenAutomationTriggersArticle = (): void =>
  intercomOpenArticleById(ARTICLE_AUTOMATION_TRIGGERS);

export const intercomOpenAutomationActionsArticle = (): void =>
  intercomOpenArticleById(ARTICLE_AUTOMATION_ACTIONS);

export const intercomOpenLimitsArticle = (): void =>
  intercomOpenArticleById(ARTICLE_SMARTSUITE_LIMITS);

export const intercomOpenIntegrationsArticle = (id: number): void =>
  intercomOpenArticleById(id);

/* eslint-disable  @typescript-eslint/no-explicit-any */
const withIntercom = (fn: (intercom: any) => void): void => {
  // @ts-expect-error
  if (window.Intercom) {
    // @ts-expect-error
    fn(window.Intercom);
  } else {
    // eslint-disable-next-line no-console
    console.warn("Intercom is disabled in this environment");
  }
};

const intercomOpenArticleById = (id: number): void => {
  withIntercom((intercom) => {
    intercom("showArticle", id);
  });
};
